import React from 'react';
import { Button } from 'carbon-components-react';
import { Close32 } from '@carbon/icons-react';

export const PAYMENT_UNSUCCESSFUL_TITLE = 'Payment unsuccessful';

export const PAYMENT_UNSUCCESSFUL_BODY =
  'Your payment could not be processed. No charge has been made to your account. Please check your card details and try again.';

interface PaymentUnsuccessfulScreenProps {
  onTryAgain: () => void;
  onCancel: () => void;
  tryAgainLabel?: string;
  cancelLabel?: string;
}

const PaymentUnsuccessfulScreen: React.FC<PaymentUnsuccessfulScreenProps> = ({
  onTryAgain,
  onCancel,
  tryAgainLabel = 'Try again',
  cancelLabel = 'Cancel'
}) => {
  return (
    <div className="payment-unsuccessful-screen">
      <div className="payment-unsuccessful-screen__container">
        <div className="payment-unsuccessful-screen__icon-bg">
          <Close32 className="payment-unsuccessful-screen__icon" />
        </div>
        <div className="payment-unsuccessful-screen__heading">
          {PAYMENT_UNSUCCESSFUL_TITLE}
        </div>
        <div className="payment-unsuccessful-screen__body">
          {PAYMENT_UNSUCCESSFUL_BODY}
        </div>
        <div className="payment-unsuccessful-screen__actions">
          <Button kind="primary" onClick={onTryAgain}>
            {tryAgainLabel}
          </Button>
          <Button kind="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentUnsuccessfulScreen;
